import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { CitationsContextWrapper } from '@vivli/shared/features/citations/infrastructure/wrappers';
import { CSSProperties } from 'react';
import { CitationsView } from '@vivli/shared/features/citations/views';

const containerStyle: CSSProperties = {
    padding: '0 40px',
};
export const DataRequestCitationsComponent = () => {
    const { dataRequest } = useDataRequestContext();

    return (
        <CitationsContextWrapper objectId={dataRequest.id} isStudy={false} doUpdate={false} doiStem={dataRequest.doiStem}>
            <div style={containerStyle}>
                <CitationsView />
            </div>
        </CitationsContextWrapper>
    );
};
